import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { omit } from 'lodash';
import {
  searchBrandedFixture,
  setSearchBrandedFixture,
  setBrandedFixturesSortCriterias,
} from './branded-fixtures-actions';
import { getLoading, getSearch, getSorting, getTotal } from './branded-fixtures-selectors';
import BaseGrid from '../grid/BaseGrid';
import SearchBrandedFixtures from '../header/search/SearchBrandedFixtures';

function BrandedFixtures() {
  const dispatch = useDispatch();
  const [isAllSelected, setIsAllSelected] = useState(false);

  const total = useSelector(getTotal);
  const search = useSelector(getSearch);
  const loading = useSelector(getLoading);
  const sorting = useSelector(getSorting);

  useEffect(() => {
    dispatch(searchBrandedFixture({ sorting }));
  }, []);

  useEffect(() => {
    dispatch(searchBrandedFixture({ ...search, sorting }));
  }, [search]);

  const onPageChange = (pageData: any) => {
    dispatch(setSearchBrandedFixture({ ...search, ...omit(pageData, 'sorting') }));
    if (pageData.sorting) {
      dispatch(setBrandedFixturesSortCriterias(pageData.sorting));
    }
  };

  return (
    <>
      <SearchBrandedFixtures />
      <BaseGrid
        id='brandedFixtures'
        total={total}
        isAllSelected={isAllSelected}
        toggleIsAllSelected={(val: boolean) => setIsAllSelected(val)}
        search={search}
        setSearch={onPageChange}
        loading={loading}
      />
    </>
  );
}

export default BrandedFixtures;
